import React from "react";
import "../cdn.scss";
const FooterWrapper = _ref => {
  let {
    heading = false,
    element
  } = _ref;
  if (element !== null && element !== void 0 && element.icon) {
    return /*#__PURE__*/React.createElement("i", {
      className: element.icon
    });
  }
  if (heading) {
    return /*#__PURE__*/React.createElement("span", {
      className: "fs-h4"
    }, element.title);
  }
  return /*#__PURE__*/React.createElement("span", null, element.title);
};
const FooterLink = _ref2 => {
  var _element$classList, _element$classList2, _element$classList3;
  let {
    element
  } = _ref2;
  const isHeading = ((_element$classList = element.classList) === null || _element$classList === void 0 ? void 0 : _element$classList.includes("heading")) || ((_element$classList2 = element.classList) === null || _element$classList2 === void 0 ? void 0 : _element$classList2.includes("heading-link")) || false;
  if (element.url && element.url.length > 0 && element.url !== "#" && (_element$classList3 = element.classList) !== null && _element$classList3 !== void 0 && _element$classList3.includes("external-link")) {
    var _element$aria;
    return /*#__PURE__*/React.createElement("a", {
      href: element.url,
      target: "_blank",
      rel: "noreferrer",
      "aria-label": ((_element$aria = element.aria) === null || _element$aria === void 0 ? void 0 : _element$aria.label) || undefined
    }, /*#__PURE__*/React.createElement(FooterWrapper, {
      element: element,
      heading: isHeading
    }), /*#__PURE__*/React.createElement("i", {
      className: "fa-regular fa-arrow-up-right-from-square"
    }), isHeading && /*#__PURE__*/React.createElement("hr", null));
  }
  if (element.url && element.url.length > 0 && element.url !== "#") {
    var _element$aria2;
    return /*#__PURE__*/React.createElement("a", {
      href: element.url,
      "aria-label": ((_element$aria2 = element.aria) === null || _element$aria2 === void 0 ? void 0 : _element$aria2.label) || undefined
    }, /*#__PURE__*/React.createElement(FooterWrapper, {
      element: element,
      heading: isHeading
    }), isHeading && /*#__PURE__*/React.createElement("hr", null));
  }
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(FooterWrapper, {
    element: element,
    heading: isHeading
  }), isHeading && /*#__PURE__*/React.createElement("hr", null));
};
export const Footer = /*#__PURE__*/React.forwardRef((_ref3, ref) => {
  let {
    columns = 3,
    links = [],
    social = [],
    className = ""
  } = _ref3;
  // Ensure columns isn't outside bounds
  if (columns > 4) {
    columns = 4;
  } else if (columns < 1) {
    columns = 1;
  }
  return /*#__PURE__*/React.createElement("footer", {
    className: ["footer", "mt-12", ...className.split(" ")].filter(v => !!v).join(" "),
    ref: ref
  }, /*#__PURE__*/React.createElement("div", {
    className: "container"
  }, links.length > 0 && /*#__PURE__*/React.createElement("div", {
    className: ["grid", "pt-11", social.length === 0 && "pb-9"].filter(v => !!v).join(" ")
  }, links.map((column, idx) => /*#__PURE__*/React.createElement("div", {
    className: ["col-".concat(12 / columns), "col-sm-12"].filter(v => !!v).join(" "),
    key: idx
  }, /*#__PURE__*/React.createElement("ul", null, column.map((item, i) => /*#__PURE__*/React.createElement("li", {
    key: i,
    className: item.classList || undefined
  }, /*#__PURE__*/React.createElement(FooterLink, {
    element: item
  }))))))), social.length > 0 && /*#__PURE__*/React.createElement("div", {
    className: "flex mt-10 pb-9"
  }, /*#__PURE__*/React.createElement("ul", {
    className: "social-icons"
  }, social.map((item, i) => /*#__PURE__*/React.createElement("li", {
    key: i,
    className: item.classList || undefined
  }, /*#__PURE__*/React.createElement(FooterLink, {
    element: item
  })))))));
});